import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';

import { SideNav } from './../side-nav/side-nav.model';


@Injectable({
  providedIn: 'root'
})
export class AppShellService {

  private sideNavItemsEmmiter: BehaviorSubject<SideNav[]> = new BehaviorSubject<SideNav[]>([]);

  private sideNavToggleEvent: BehaviorSubject<{ state: string, value: number; }> = new BehaviorSubject<{ state: string, value: number; }>({} as any);
  onSideNavToggleEvent: Observable<{ state: string, value: number; }> = this.sideNavToggleEvent.asObservable();

  onSideNavItems = this.sideNavItemsEmmiter.asObservable();
  constructor(private router: Router) {
  }

  changeSideNavItems(items: SideNav[]) {
    this.sideNavItemsEmmiter.next(items);
  }

  changeSideNavToggleEvent(data: { state: string, value: number; }) {
    console.log(data);
    this.sideNavToggleEvent.next(data);
  }




}
